import { useEffect, useState } from 'react';
import './NewProject.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { projectStatusOptions } from '../../utilities/services/projectsOptions';
import { createProject, findProject } from '../../utilities/api/projectsTimeline';
import { findClientByNumber } from '../../utilities/api/clients';



export default function NewProject({user, users, services, updateProjects, toggleNotifications}) {
    const projNumReg = /^([A-Z]{2}-[0-9]{4}\.[0-9]{2,}\.[0-9]{3})$/g
    const [isValidProjNum, setIsValidProjNum] = useState(false)
    const [isAvailableProjNum, setIsAvailableProjNum] = useState(false)
    const [activeUsers, setActiveUsers] = useState([])
    const defaultState = {
        projType: '',
        projNum: '',
        projTitle: '',
        clientName: '',
        clientNumber: '',
        clientID: '',
        assignedAnalystId: '',
        managerID: '',
        contractStatus: 'incomplete',
        contractURL: '',
        ndaStatus: 'incomplete',
        ndaURL: '',
        formURL: '',
        projectReportURL: '',
        dueDate: '',
        clientDeadline: '',
        firstInvoiceStatus: 'pending',
        firstInvoiceURL: '',
        projectStatus: 'unassigned',
        projectReportStatus: 'pending',
        secondInvoiceStatus: 'pending',
        secondInvoiceURL: '',
        otherURL1: '',
        otherURL2: '',
        otherURL3: '',
        otherURL4: '',
    }
    const [formData, setFormData] = useState(defaultState)

    const handleSubmit = async (evt) =>{
        evt.preventDefault();
        // console.log(formData)
        try {
            const updatedProjectList = await createProject(formData)
            await toggleNotifications('success', `New Project "${formData.projNum}" Created!`, '#FFFFFF')
            setFormData(defaultState)
            await updateProjects(updatedProjectList)
            // Reset form
            document.getElementById('newProjectForm').reset()
            setIsAvailableProjNum(false)
            setIsValidProjNum(false)
        } catch (error) {
            await toggleNotifications('error', `Failed to Create Project "${formData.projNum}"!`, '#FFFFFF')
            console.log(error)
        }
    }

    const checkProjNum = async (evt) => {
        const projNum = evt.target.value
        // console.log(projNum)
        if (projNumReg.test(projNum)) {
          setIsValidProjNum(true)
          try {
            const project = await findProject(projNum)
            if (project) {
              setIsAvailableProjNum(false)
            } else {
              setIsAvailableProjNum(true)
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          setIsValidProjNum(false)
        }
    }

    const checkForClient = async (clientNumber) => {
        try {
            const client = await findClientByNumber(clientNumber)
            if (client) {
                return client
            } else {
                return null
            }
        } catch (err) {
            console.log(err)
        }
    }

    async function handleChange(evt) {
        const newFormData = {
          ...formData,
          [evt.target.name]: evt.target.value,
        };
        
        if (evt.target.name === 'projNum') {
            checkProjNum(evt)
        }
        setFormData(newFormData);
        
        if (evt.target.name === 'clientNumber') {
            const clientNumber = evt.target.value
            if (clientNumber) {
                // Use async/await in an IIFE (Immediately Invoked Function Expression) to avoid blocking UI
                (async () => {
                    try {
                        const client = await checkForClient(clientNumber);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            clientName: client ? client.companyName : '',
                            clientID: client ? client._id : ''
                        }));
                    } catch (error) {
                        console.error('Error checking for client:', error);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            clientName: '',
                            clientID: ''
                        }));
                    }
                })();
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    clientName: '',
                    clientID: ''
                }));
            }
        }
    }

    useEffect(() => {
        setActiveUsers(users.filter(user => user.status === 'active'))
        // eslint-disable-next-line
    }, [users])

    const disabled = !projNumReg.test(formData.projNum) || !formData.projTitle || !formData.projType || !formData.clientName || !formData.clientNumber || !isAvailableProjNum
  return (
    <div className='NewProject modal fade' id={`newProjectModal`}  data-bs-keyboard="true">
        <div className="modal-dialog">
            <div className="modal-content formContainer">
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M8.75 2.625H2.625V8.75H8.75V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 2.625H12.25V8.75H18.375V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 12.25H12.25V18.375H18.375V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.75 12.25H2.625V18.375H8.75V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                Add New Project 
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <form onSubmit={handleSubmit} id={`newProjectForm`}>
                    <div className='formContent'>
                        <div className='form-group projNum'>
                            <div className='input'>
                                <label htmlFor="projectProjNum">Project Number <span className='requiredField'><strong>*</strong></span></label>
                                <input className='form-control' type="text" name="projNum" id='projectProjNum' placeholder='Enter Project Number' value={formData.projNum} onChange={handleChange} required autoComplete='off'/>
                            </div>
                            <div className='projectNumberStatus'>
                                <small className="form-text checkIsValidProjectNum" style={{backgroundColor:`${isValidProjNum? 'green' : 'red'}`, color:'white'}}>Format: XX-0000.00.000</small>
                                {isValidProjNum &&
                                <span className="form-text checkProjNum" style={{color:`${isAvailableProjNum? 'green' : 'red'}`}}>
                                    <strong>
                                        {isAvailableProjNum ? <span>{[<span key={0}>&#x2714;</span>]}</span> : 'Project number already exists!'}
                                    </strong>
                                </span>
                                }
                            </div>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectProjType`} className='form-label'>Project Type <span className='requiredField'><strong>*</strong></span></label>
                            <select id={`projectProjType`} name='projType' className='form-select' defaultValue={formData.projType} onChange={handleChange}>
                                <option value="" disabled>---</option>
                                { services && services.map((service, index) => (
                                    <option key={index} value={service.code}>{capitalizeFirstLetter(service.name)}</option>
                                ))}
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectProjTitle`} className='form-label'>Project Title <span className='requiredField'><strong>*</strong></span></label>
                            <input type="text" id={`projectProjTitle`} name='projTitle' className='form-control' defaultValue={formData.projTitle} placeholder='Add title here' onChange={handleChange}/>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectClientNumber`} className='form-label'>Client Number <span className='requiredField'><strong>*</strong></span></label>
                            <input type="number" id={`projectClientNumber`} name='clientNumber' className='form-control' defaultValue={formData.clientNumber} placeholder='Add client number' onChange={handleChange}/>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectClientName`} className='form-label'>Client Name <span className='requiredField'><strong>*</strong></span></label>
                            <input type="text" id={`projectClientName`} name='clientName' className='form-control' value={formData.clientName} placeholder='Add client name here' onChange={handleChange}/>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectManager`} className='form-label'>Manager</label>
                            <select id={`projectManager`} name='managerID' className='form-select' defaultValue={formData.managerID} onChange={handleChange}>
                            <option value="" disabled>---</option>
                            { activeUsers&& activeUsers.map((user, index) => (
                                <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                            ))}
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectAssignee`} className='form-label'>Analyst</label>
                            <select id={`projectAssignee`} name='assignedAnalystId' className='form-select' defaultValue={formData.assignedAnalystId} onChange={handleChange}>
                            <option value="" disabled>---</option>
                            { activeUsers.map((user, index) => (
                                <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                            ))}
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectProjectStatus`} className='form-label'>Project</label>
                            <select id={`projectProjectStatus`} name='projectStatus' className={`form-select status ${formData.projectStatus}`} defaultValue={formData.projectStatus} onChange={handleChange}>
                                <option value="" disabled>---</option>
                                { projectStatusOptions.map((projectStatus, index) => (
                                    <option key={index} value={projectStatus.value}>{capitalizeFirstLetter(projectStatus.name)}</option>
                                ))}
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectContractStatus`} className='form-label'>Contract</label>
                            <select id={`projectContractStatus`} name='contractStatus' className={`form-select status ${formData.contractStatus}`} defaultValue={formData.contractStatus} onChange={handleChange}>
                                <option value="complete">Complete</option>
                                <option value="incomplete">Incomplete</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectNdaStatus`} className='form-label'>NDA</label>
                            <select id={`projectNdaStatus`} name='ndaStatus' className={`form-select status ${formData.ndaStatus}`} defaultValue={formData.ndaStatus} onChange={handleChange}>
                                <option value="complete">Complete</option>
                                <option value="incomplete">Incomplete</option>
                                <option value="na">N/A</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectDueDate`} className='form-label'>Analyst Deadline</label>
                            <input type="date" id={`projectDueDate`} name='dueDate' className='form-control' defaultValue={formData.dueDate} onChange={handleChange}/>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectClientDeadline`} className='form-label'>Client Deadline</label>
                            <input type="date" id={`projectClientDeadline`} name='clientDeadline' className='form-control' defaultValue={formData.clientDeadline} onChange={handleChange}/>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectFirstInvoiceStatus`} className='form-label'>First Invoice</label>
                            <select id={`projectFirstInvoiceStatus`} name='firstInvoiceStatus' className={`form-select status ${formData.firstInvoiceStatus}`} defaultValue={formData.firstInvoiceStatus} onChange={handleChange}>
                                <option value="na">N/A</option>
                                <option value="pending">Pending</option>
                                <option value="sent">Sent</option>
                                <option value="paid">Paid</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectProjectReportStatus`}> Project Report</label>
                            <select id={`projectProjectReportStatus`} name='projectReportStatus' className={`form-select status ${formData.projectReportStatus}`} defaultValue={formData.projectReportStatus} onChange={handleChange}>
                                <option value="generated">Generated</option>
                                <option value="pending">Pending</option>
                                <option value="na">N/A</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label htmlFor={`projectSecondInvoiceStatus`} className='form-label'>Second Invoice</label>
                            <select id={`projectSecondInvoiceStatus`} name='secondInvoiceStatus'  className={`form-select status ${formData.secondInvoiceStatus}`} defaultValue={formData.secondInvoiceStatus} onChange={handleChange}>
                                <option value="na">N/A</option>
                                <option value="pending">Pending</option>
                                <option value="sent">Sent</option>
                                <option value="paid">Paid</option>
                            </select>
                        </div>
                        <div className='linksContainer'>
                            <div className='linksHeader'>Useful Links</div>
                            <div className='form-group'>
                                <label htmlFor={`projectContractURL`} className='form-label'>Contract</label>
                                <input type="text" id={`projectContractURL`} name='contractURL' className='form-control' defaultValue={formData.contractURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectNdaURL`} className='form-label'>NDA</label>
                                <input type="text" id={`projectNdaURL`} name='ndaURL' className='form-control' defaultValue={formData.ndaURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectFormURL`} className='form-label'>Form</label>
                                <input type="text" id={`projectFormURL`} name='formURL' className='form-control' defaultValue={formData.formURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectFirstInvoiceURL`} className='form-label'>First Invoice</label>
                                <input type="text" id={`projectFirstInvoiceURL`} name='firstInvoiceURL' className='form-control' defaultValue={formData.firstInvoiceURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectSecondInvoiceURL`} className='form-label'>Second Invoice</label>
                                <input type="text" id={`projectSecondInvoiceURL`} name='secondInvoiceURL' className='form-control' defaultValue={formData.secondInvoiceURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectProjectReportURL`} className='form-label'>Project Report</label>
                                <input type="text" id={`projectProjectReportURL`} name='projectReportURL' className='form-control' defaultValue={formData.projectReportURL} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectOtherURL1`} className='form-label'>Other Link 1</label>
                                <input type="text" id={`projectOtherURL1`} name='otherURL1' className='form-control' defaultValue={formData.otherURL1} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectOtherURL2`} className='form-label'>Other Link 2</label>
                                <input type="text" id={`projectOtherURL2`} name='otherURL2' className='form-control' defaultValue={formData.otherURL2} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectOtherURL3`} className='form-label'>Other Link 3</label>
                                <input type="text" id={`projectOtherURL3`} name='otherURL3' className='form-control' defaultValue={formData.otherURL3} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor={`projectOtherURL4`} className='form-label'>Other Link 4</label>
                                <input type="text" id={`projectOtherURL4`} name='otherURL4' className='form-control' defaultValue={formData.otherURL4} placeholder='Add link here' onChange={handleChange}/>
                            </div>
                        </div>
                    </div>
                </form>
                <div className='d-flex justify-content-center formButtonContainer'>
                    <button data-bs-dismiss="modal" className='cancel'>
                        Cancel
                    </button>
                    <button data-bs-dismiss="modal" className="primary submit" type="submit" form={`newProjectForm`} disabled={disabled}>
                        Create Project
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
